import { render, staticRenderFns } from "./LalamoveOrder.vue?vue&type=template&id=1a0437e1&scoped=true&"
import script from "./LalamoveOrder.vue?vue&type=script&lang=js&"
export * from "./LalamoveOrder.vue?vue&type=script&lang=js&"
import style0 from "./LalamoveOrder.vue?vue&type=style&index=0&id=1a0437e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0437e1",
  null
  
)

export default component.exports